var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Loading } from 'element-ui';
import GLOBAL_VUE from '../../globalVue';
import RejectStockInOrderService from '../../api/RejectStockInOrderService';
import CommonService from '../../api/CommonService';
import Header from './components/DetailHeader';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.order_id = '';
        _this.formData = {};
        _this.data = [];
        _this.supplierGoodsTypeList = [];
        _this.goodsFormData = {
            goods_type_id: undefined,
            keyword: '',
        };
        _this.dialogVisible = false;
        _this.reject_reason = '';
        return _this;
    }
    default_1.prototype.created = function () {
        this.service = RejectStockInOrderService.getInstance();
        this.commonService = CommonService.getInstance();
        this.getDetail();
        this.getGoodsTypeList();
    };
    default_1.prototype.mounted = function () {
        var _this = this;
        var timeout = setTimeout(function () {
            clearTimeout(timeout);
            _this.tableHeight = document.documentElement.clientHeight - 370;
        }, 300);
    };
    default_1.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    default_1.prototype.search = function () {
        this.getDetail();
    };
    default_1.prototype.getGoodsTypeList = function () {
        var _this = this;
        this.commonService.getSupplierGoodsTypeList().then(function (res) {
            if (res.data.success) {
                _this.supplierGoodsTypeList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.order_id,
            goods_type_id: this.goodsFormData.goods_type_id,
            keyword: this.goodsFormData.keyword,
        };
        this.service
            .getDetail(params)
            .then(function (res) {
            loadingInstance.close();
            var data = res.data.data || [];
            data.detail.map(function (item) {
                item.realityStoreIn = Math.floor(item.order_warehousing_amount * item.sales_unit_coefficient * 10000) / 10000;
                item.realityLose = Math.floor(item.order_loss_amount * item.sales_unit_coefficient * 10000) / 10000;
                return item;
            });
            _this.formData = data;
            _this.data = data.detail || [];
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.closeReject = function () {
        this.dialogVisible = false;
    };
    default_1.prototype.reject = function () {
        this.dialogVisible = true;
        this.reject_reason = '';
    };
    default_1.prototype.doReject = function () {
        var _this = this;
        if (this.reject_reason.length > 100) {
            this.$message.error('驳回原因不能超过100字');
            return;
        }
        var params = {
            order_ids: this.order_id,
            reject_reason: this.reject_reason,
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.reject(params).then(function (res) {
            loadingInstance.close();
            _this.$message.success(res.data.msg || '操作成功');
            _this.closeReject();
            var timeout = setTimeout(function () {
                clearTimeout(timeout);
                GLOBAL_VUE.$emit('closeTab', _this);
                if (_this.opener) {
                    _this.opener.getList();
                }
            }, 500);
            window._czc.push([
                '_trackEvent',
                '修改退货入库单',
                '退货入库单驳回',
            ]);
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    default_1 = __decorate([
        Component({
            components: {
                'detail-header': Header,
            },
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
